module.exports = __webpack_public_path__ + "img/story006.8f8ea58a.webp";